import { $host } from ".";

// Get all photos
export const fetchPhotos = async () => {
    try {
        const { data } = await $host.get('api/photo');
        return data;
    } catch (error) {
        console.error("Error fetching photos:", error);
        return error;
    }
};

// Get one photo by ID
export const fetchPhoto = async (id) => {
    try {
        const { data } = await $host.get('api/photo/id/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching photo:", error);
        return error;
    }
};

// Create a new photo
export const createPhoto = async (photo) => {
    try {

        const { data } = await $host.post('api/photo', photo, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        return data;
    } catch (error) {
        console.error("Error creating photo:", error);
        return error;
    }
};

// Update an existing photo
export const updatePhoto = async (id, photo) => {
    try {
        const formData = new FormData();
        for (const key in photo) {
            formData.append(key, photo[key]);
        }

        const { data } = await $host.put('api/photo/' + id, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        return data;
    } catch (error) {
        console.error("Error updating photo:", error);
        return error;
    }
};

// Delete a photo
export const deletePhoto = async (id) => {
    try {
        const { data } = await $host.delete('api/photo/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting photo:", error);
        return error;
    }
};
